/**
 * Typed tenant features API facade over the generated contract client.
 */

import { tenantFeaturesApi } from '../api/generated/tenantFeatures.api.js';
import { type TenantCapabilitiesResponse } from '@cnapse/shared/schemas.js';

class TenantFeaturesService {
  async getTenantCapabilities(): Promise<TenantCapabilitiesResponse> {
    return tenantFeaturesApi.getCapabilities() as Promise<TenantCapabilitiesResponse>;
  }
}

export const tenantFeaturesService = new TenantFeaturesService();
